import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 63281 22413"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M31641 10247c5166 0 10325 589 15358 1749V9939c-10064-2390-20652-2389-30717 1v2056c5033-1160 10193-1748 15359-1749zm16348 3991c-81 0-161-8-241-29-10539-2635-21679-2634-32215 0-297 74-610 9-850-179-241-188-380-475-380-780V9163c0-453 310-850 750-960 5420-1354 11000-2041 16588-2041 5585 0 11166 688 16588 2041 438 110 748 507 748 961l1 4085c0 306-141 593-383 781-174 137-389 208-606 208z"
        className="fil0"
      />
      <path
        d="M48978 20435h2109V1978h-2109v18457zm3096 1978h-4085c-547 0-990-441-990-989V989c0-546 443-989 990-989h4085c546 0 989 443 989 989v20434c0 549-443 990-989 990z"
        className="fil0"
      />
      <path
        d="M53063 18392h2109V4020h-2109v14372zm3099 1976h-4088c-544 0-987-440-987-986V3033c0-546 443-989 987-989h4088c547 0 990 444 990 990v16348c0 545-444 987-990 987v-1z"
        className="fil0"
      />
      <path
        d="M57152 16348h2108V6064h-2108v10284zm3096 1978h-4086c-546 0-990-442-990-989V5075c0-546 444-987 990-987h4086c546 0 990 441 990 987v12262c0 547-444 989-990 989zM12194 20435h2109V1978h-2109v18457zm3099 1978h-4088c-545 0-988-441-988-989V989c0-546 443-989 988-989h4088c546 0 989 443 989 989v20434c0 549-443 990-989 990z"
        className="fil0"
      />
      <path
        d="M8108 18392h2109V4020H8108v14372zm3097 1976H7119c-547 0-990-440-990-986l1-16349c0-546 442-989 989-989h4086c546 0 989 444 989 990v16348c0 545-443 987-989 987v-1z"
        className="fil0"
      />
      <path
        d="M4020 16348h2110V6064H4020v10284zm3099 1978H3031c-544 0-987-442-987-989V5075c0-546 443-987 987-987h4088c546 0 988 441 988 987l1 12262c0 547-443 989-989 989zM62291 12195h-2043c-545 0-988-441-988-988 0-546 443-989 988-989h2043c547 0 990 443 990 989 0 547-443 988-990 988z"
        className="fil0"
      />
      <path
        d="M3031 12195H989c-546 0-989-441-989-988 0-546 443-989 988-989h2043c546 0 989 443 989 989 0 547-443 988-989 988z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
